<template>
  <div class="allApp">
    <el-button
      type="primary"
      @click="goPage('VaccinumCardDetail')"
    >心意卡激活状态查询</el-button>
    <el-button
      type="primary"
      @click="goPage('FormHome')"
    >工单</el-button>
    <el-button
      type="primary"
      @click="goPage('AppointmentHome')"
    >看诊预约</el-button>
    <el-button
      type="primary"
      @click="goPage('BookingRefund')"
    >回款</el-button>
    <el-button
      type="primary"
      @click="goPage('ReserveCalendar')"
    >预约监控</el-button>
    <el-button
      type="primary"
      @click="goPage('ReserveAchievement')"
    >门诊渠道业绩统计</el-button>
    <el-button
      type="primary"
      @click="goPage('BookingHome')"
    >统一预约</el-button>
    <el-button
      type="primary"
      @click="goPage('SalonHome')"
    >沙龙预约</el-button>
    <el-button
      type="primary"
      @click="goPage('CustomerSearch')"
    >天润客户信息查询</el-button>

  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {};
  },
  components: {},
  methods: {
    goPage(pathName) {
      this.$router.push({
        name: pathName,
      });
    },
  },
};
</script>

<style scoped>
</style>
